(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ma-header"]) return;
  try {
    
document.addEventListener('click',function(event){document.querySelectorAll('.ma-contact-disclosure[open]').forEach(function(panel){if(!panel.contains(event.target)){panel.open=false;}});});
document.addEventListener('keydown',function(event){if(event.key==='Escape'){document.querySelectorAll('.ma-contact-disclosure[open]').forEach(function(panel){panel.open=false;panel.querySelector('summary').focus();});}});

  } catch(e) { console.error(e); }
})();
})();
